export default "__VITE_ASSET__CTtYrU5a__"